// Campus photo for /colleges/university-of-south-florida: CC BY 4.0, by Trevorrrrvalent, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AInterdisciplinary_Sciences_Building_North_University_of_South_Florida_2024.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-south-florida/; credited under the photo.
const photo = {
    "slug": "university-of-south-florida",
    "alt": "The Interdisciplinary Sciences Building behind cypress trees on the University of South Florida campus in Tampa",
    "src": "/colleges/university-of-south-florida/campus-1600.webp",
    "srcSmall": "/colleges/university-of-south-florida/campus-800.webp",
    "srcMid": "/colleges/university-of-south-florida/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-south-florida/og.jpg",
    "title": "Interdisciplinary Sciences Building North University of South Florida 2024",
    "author": "Trevorrrrvalent",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AInterdisciplinary_Sciences_Building_North_University_of_South_Florida_2024.jpg",
    "read": "2026-10-02"
};

export default photo;
